import './Component.css';

import {
  Checkbox,
  Grid,
  Icon,
  InputAdornment,
  MenuItem,
  Select,
  TextField as TextFieldUI,
  ButtonGroup as MuiButtonGroup,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@mui/material';
import React, { Component } from 'react';

// Local ButtonGroup component to replace vardogyir-ui/ButtonGroup
const ButtonGroup = ({ data, onClickButton, size = 'medium', ...props }) => (
  <MuiButtonGroup {...props} size={size}>
    {data && data.map((bt, index) => (
      <Button
        key={index}
        color="primary"
        variant={bt.active ? 'contained' : 'outlined'}
        size={size}
        onClick={() => onClickButton(bt.key)}
      >
        {bt.name}
      </Button>
    ))}
  </MuiButtonGroup>
);
import Calendar from './FormComponents/Calendar';
import ChipInput from '../ChipInput/ChipInput';
import ChoiceQuestion from '../FormBuilder/ConfigComponents/ChoiceQuestion';
import ErrorIcon from '@mui/icons-material/Error';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { FROM_DB } from '../../utils/FormUtil';
import FormMentionEditor from '../Component/FormMentionEditor';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import { uploadImage } from '../TipTap/CustomImage';
import FormPredertermine from './FormConditionals/FormPredertermine';
import useFormPredertermineStore from './FormConditionals/FormConditionStores/useFormPredertermineStore';
import FormReadOnly from './FormConditionals/FormReadOnly';
import useFormReadOnlyStore from './FormConditionals/FormConditionStores/useFormReadOnlyStore';
import FormRequired from './FormConditionals/FormRequired';
import useFormRequiredStore from './FormConditionals/FormConditionStores/useFormRequiredStore';
import FormVisibility from './FormConditionals/FormVisibility';
import useFormVisibilityStore from './FormConditionals/FormConditionStores/useFormVisibilityStore';
import PropTypes from 'prop-types';
import RepeatableSection from '../FormBuilder/FormComponents/Table/RepeatableSection';
import SequentialFormContainer from './SequentialFormContainer';
import Table from '../FormBuilder/FormComponents/Table/Table';
import Tooltip from '@mui/material/Tooltip';
import VideoEmbed from '../FormBuilder/ConfigComponents/VideoEmbed';
import { createTheme } from '@mui/material/styles';
import replacePlaceholderValue from '../../utils/ReplacePlaceholderValue';
import uuid from 'uuid';
import { withStyles } from '@mui/styles';
import TextValidation from '../FormBuilder/ConfigComponents/TextValidation';
import NumberValidation from '../FormBuilder/ConfigComponents/NumberValidation';
import W86PlaceholderTextField from '../W86Components/W86PlaceholderTextField';

const styles = theme => ({
  textroot: {
    width: '100%',
    margin: 'auto',
  },
  formAreaInput: {
    padding: '8px!important',
  },
  insertPlaceholderButton: {
    cursor: 'pointer',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    '&:hover': {
      color: 'var(--color-text-primary)',
    },
    paddingTop: '4px',
  },
  searchableSelect: {
    textAlign: 'center',
  },
  textFieldUI: {
    marginTop: 16,
    width: '90%',
    '& > div': {
      height: 40,
    },
  },
  filePreviewURL: {
    fontSize: 14,
    marginTop: 16,
    marginBottom: 8,
  },
  filePreviewDescription: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: 8,
  },
  centerGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  warningText: {
    fontSize: '12px',
  },
  warningGrid: {
    borderRadius: '4px',
    border: '1px solid #FFB74D',
    background: '#FFEACB',
  },
  warningIcon: {
    color: '#FFB74D',
    margin: '8px',
  },
});

const columnId = uuid();

const newColumn = {
  id: columnId,
  type: 'text',
  columnName: 'Column 1',
  question: 'Question 1',
  description: '',
  options: [
    {
      id: uuid(),
      value: '',
      label: '',
    },
  ],
  dtFormat: {
    outputFormat: 'dd/MM/YYYY kk:mm',
    timezone: 'GMT+10',
  },
  required: false,
};

const tableCells = {};
tableCells[columnId] = [
  {
    id: 'row1',
    isRequired: false,
    isDisabled: false,
    isReadOnly: false,
    defaultValue: '',
    rawValue: '',
  },
  {
    id: 'row2',
    isRequired: false,
    isDisabled: false,
    isReadOnly: false,
    defaultValue: '',
    rawValue: '',
  },
  {
    id: 'row3',
    isRequired: false,
    isDisabled: false,
    isReadOnly: false,
    defaultValue: '',
    rawValue: '',
  },
];

const initialRowLabels = [
  {
    rowNumber: '1',
    rowLabel: '',
    rowKey: 'row1',
  },
  {
    rowNumber: '2',
    rowLabel: '',
    rowKey: 'row2',
  },
  {
    rowNumber: '3',
    rowLabel: '',
    rowKey: 'row3',
  },
];

class ComponentConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      required: false,
      requiredText: '',
      visibility: true,
      visibilityText: '',
      readonly: false,
      readonlyText: '',
      comment: false,
      autoAnswer: '',
      auto_answer: '',
      notificationEmails: {
        emailList: [],
        shouldNotify: false,
      },
      question_description_default: null,
      question_text_default: null,
      key: '',
      dataAuto: [],
      dataVisibility: [],
      dataReadOnly: [],
      dataRequired: [],
      dataComment: [],
      advancedExpand: false,
      answer_list: [['', '']],
      answer_data_default: null,
      defaultContent: null,
      drop_down: '',
      checkKey: false,
      valueError: '',
      tableErrors: '',
      list_value_restrict: 0,
      minItems: 0,
      maxItems: 0,
      outputFormat: 'dd/MM/YYYY',
      dateOnly: false,
      timezone: 'UTC',
      updateState: false,
      labelColumnId: '',
      valueColumnId: '',
      numRows: 3,
      exportType: 'columnsAsLists',
      exportFormat: 'JSON',
      columns: [newColumn],
      tableCells: tableCells,
      rowLabels: initialRowLabels,
      contentBlockPlaceholders: [],
      availablePlaceholders: this.props.availablePlaceholders,
      file_type: 'pdf',
      sourceMode: 'user_upload',
      presetImageUrl: '',
      addressFields: {
        line1: { show: true, required: true },
        line2: { show: true, required: false },
        locality: { show: true, required: true },
        region: { show: true, required: true },
        postalCode: { show: true, required: true },
        country: { show: true, required: true },
      },
      size: 'RESPONSIVE',
      height: '',
      width: '',
      embedType: 'URL',
      url: '',
      snippet: '',
      validation: {
        min: '',
        max: '',
        message: '',
        regex: '',
      },
    };
    this.handleChangeOutput = this.handleChangeOutput.bind(this);
    this.handleChangeTimezone = this.handleChangeTimezone.bind(this);
    this.handleChangeDateOnly = this.handleChangeDateOnly.bind(this);
    this.handlePoppair = this.handlePoppair.bind(this);
    this.handleAddpair = this.handleAddpair.bind(this);
    this.handleAnswerpair = this.handleAnswerpair.bind(this);
    this.handleReplaceAnswerList = this.handleReplaceAnswerList.bind(this);
    this.questionMentionInstance = React.createRef();
    this.questionDescnMentionInstance = React.createRef();
    this.contentBlockTextEditorInstance = React.createRef();
    this.inputPretermineInstance = React.createRef();
  }

  componentDidMount() {
    if (SequentialFormContainer.editTarget.config) {
      const data = SequentialFormContainer.editTarget;

      this.setState({
        advancedExpand: true,
      });

      this.setState(state => {
        const config = { ...SequentialFormContainer.editTarget.config };
        if (!config.tableCells && config.columns && !Array.isArray(config.columns)) {
          config.tableCells = config.columns;
          config.columns = Object.keys(config.tableCells).map((colId, i) => ({
            id: colId,
            type: 'text',
            columnName: `Column ${i + 1}`,
            question: `Question ${i + 1}`,
            description: '',
            options: [{ id: colId + '_opt', value: '', label: '' }],
            dtFormat: { outputFormat: 'dd/MM/YYYY kk:mm', timezone: 'GMT+10' },
            required: false,
          }));
        } else if ((!config.columns || (Array.isArray(config.columns) && config.columns.length === 0)) && config.tableCells && Object.keys(config.tableCells).length > 0) {
          config.columns = Object.keys(config.tableCells).map((colId, i) => ({
            id: colId,
            type: 'text',
            columnName: `Column ${i + 1}`,
            question: `Question ${i + 1}`,
            description: '',
            options: [{ id: colId + '_opt', value: '', label: '' }],
            dtFormat: { outputFormat: 'dd/MM/YYYY kk:mm', timezone: 'GMT+10' },
            required: false,
          }));
        }
        return config;
      });
      const loadedAddressFieldConfig = data.config.addressFields;
      if (loadedAddressFieldConfig) {
        this.setState({
          addressFields: this.normalizeAddressFieldConfig(loadedAddressFieldConfig),
        });
      }
      if (data.config.maxItems > 0 && data.config.minItems > 0)
        return this.setState({ list_value_restrict: 3 });
      else if (data.config.minItems > 0) return this.setState({ list_value_restrict: 2 });
      else if (data.config.maxItems > 0) return this.setState({ list_value_restrict: 1 });
      else return this.setState({ list_value_restrict: 0 });
    }
  }

  normalizeAddressFieldConfig = addressFields => {
    const defaults = {
      line1: { show: true, required: true },
      line2: { show: true, required: false },
      locality: { show: true, required: true },
      region: { show: true, required: true },
      postalCode: { show: true, required: true },
      country: { show: true, required: true },
    };

    const nextConfig = { ...defaults, ...(addressFields || {}) };
    Object.keys(nextConfig).forEach(key => {
      const current = {
        ...(defaults[key] || { show: true, required: false }),
        ...(nextConfig[key] || {}),
      };
      if (!current.show) {
        current.required = false;
      }
      nextConfig[key] = current;
    });
    return nextConfig;
  };

  handleAddressFieldConfigChange = (fieldKey, configKey) => event => {
    const checked = event.target.checked;
    this.setState(prevState => {
      const currentConfig = this.normalizeAddressFieldConfig(prevState.addressFields);
      const nextField = {
        ...(currentConfig[fieldKey] || { show: true, required: false }),
        [configKey]: checked,
      };

      if (configKey === 'show' && !checked) {
        nextField.required = false;
      }
      if (configKey === 'required' && checked) {
        nextField.show = true;
      }

      return {
        addressFields: {
          ...currentConfig,
          [fieldKey]: nextField,
        },
      };
    });
  };

  handleRecurseTree = (ele, key) => {
    let i = 0;

    const toBeTraversedArray = [ele];
    toBeTraversedArray.push(ele);

    while (toBeTraversedArray.length > 0) {
      let currentNode = toBeTraversedArray.shift();

      currentNode.id = `${key}-${i}`;
      if (i === 1) currentNode.className = 'annotation-content-block';
      i++;

      if (currentNode.childNodes.length > 0) {
        toBeTraversedArray.push(...currentNode.childNodes);
      }
    }

    return ele;
  };

  addIdsToContentBlock = (html, key) => {
    let parser = new DOMParser();
    let htmlDoc = parser.parseFromString(html, 'text/html');
    const newEle = this.handleRecurseTree(htmlDoc.body, key);
    return newEle.outerHTML;
  };

  handleSave = () => {
    if (!this.state.checkKey && this.state.tableErrors === '') {
      const {
        dataAuto,
        dataVisibility,
        dataReadOnly,
        dataRequired,
        dataComment,
        notificationEmails,
        optionsSource,
        size,
        height,
        width,
        embedType,
        url,
        snippet,
      } = this.state;
      let data = {
        ...this.state,
        required: this.filterBoolean(dataRequired, useFormRequiredStore.getState().Statement),
        comment: this.filterBoolean(dataComment, useFormRequiredStore.getState().Statement),
        visibility: this.filterBoolean(dataVisibility, useFormVisibilityStore.getState().Statement),
        readonly: this.filterBoolean(dataReadOnly, useFormReadOnlyStore.getState().Statement),
        autoAnswer: this.filterString(dataAuto, useFormPredertermineStore.getState().Statement),
        notificationEmails: notificationEmails
          ? notificationEmails
          : {
              emailList: [],
              shouldNotify: false,
            },
        optionsSource: optionsSource ? optionsSource : 'manually',
        minItems: this.filterListMin(),
        maxItems: this.filterListMax(),
        outputFormat: this.state.outputFormat,
        dateOnly: this.state.dateOnly,
        timezone: this.state.timezone,
        contentBlockPlaceholders: [],
        valueColumnId: this.state.valueColumnId,
        labelColumnId: this.state.labelColumnId,
        databaseId: this.state.databaseId,
        columnId: this.state.columnId,
        size: size,
        height: height,
        width: width,
        embedType: embedType,
        url: url,
        snippet: snippet,
      };
      const type = SequentialFormContainer.editTarget.type;

      // Clear database vals if not from database
      if (optionsSource !== FROM_DB) {
        data['databaseId'] = '';
        data['columnId'] = '';
        data['valueColumnId'] = '';
        data['labelColumnId'] = '';
      }

      // need to put a check on type so that Ids are added only for content block no for file preview urls.
      if (type == 11 && this.state.answer_data_default) {
        const new_data_default = this.addIdsToContentBlock(
          this.state.answer_data_default,
          this.state.key
        );
        data['answer_data_default'] = new_data_default;
      }

      for (let i in data.answer_list) {
        if (!data.answer_list[i][0]) {
          data.answer_list[i][0] = data.answer_list[i][1];
        }
      }
      SequentialFormContainer.saveConfig(data);
      this.props.checkPlaceholderForm('onSave');
    }

    this.setState({ contentBlockPlaceholders: [] });
  };

  filterString = (ButtonGroup, Statement) => {
    let data = '';
    if (ButtonGroup[2].active) {
      data = Statement;
    } else if (ButtonGroup[0].active) {
      data = this.state.autoAnswer;
    }
    return data;
  };

  filterBoolean = (ButtonGroup, Statement) => {
    let data = false;
    if (ButtonGroup[2] && ButtonGroup[2].active) {
      data = Statement;
    } else if (ButtonGroup[0].active) {
      data = true;
    }
    return data;
  };
  filterListMin = () => {
    if (this.state.list_value_restrict != 0) {
      if (this.state.list_value_restrict == 2 || this.state.list_value_restrict == 3)
        return this.state.minItems;
    } else {
      return 0;
    }
    return 0;
  };
  filterListMax = () => {
    if (this.state.list_value_restrict != 0) {
      if (this.state.list_value_restrict == 1 || this.state.list_value_restrict == 3)
        return this.state.maxItems;
    } else {
      return 0;
    }
    return 0;
  };
  handleAddpair = () => {
    this.setState(state => {
      state.answer_list.push(['', '']);
      return { answer_list: state.answer_list };
    });
  };
  handlePoppair = index => {
    this.setState(state => {
      state.answer_list.splice(index, 1);
      return { answer_list: state.answer_list };
    });
  };
  handleAnswerpair = (index, type, value) => {
    let output = value;
    this.setState(state => {
      state.answer_list[index][type] = output;
      return { answer_list: state.answer_list };
    });
  };
  handleReplaceAnswerList = newAnsList => {
    this.setState({ answer_list: newAnsList });
  };
  handleChange = event => {
    this.setState({ [event.target.value]: !this.state[event.target.value] });
  };
  handleChangeOutput(e) {
    this.setState({ outputFormat: e.target.value });
  }
  handleChangeTimezone(e) {
    this.setState({ timezone: e.target.value });
  }
  handleChangeDateOnly(checked) {
    this.setState({ dateOnly: checked });
    if (checked && this.state.outputFormat.includes('kk:mm')) {
      this.setState({ outputFormat: this.state.outputFormat.replace(' kk:mm', '') });
    }
    if (checked && this.state.outputFormat === 'Iso-8601') {
      this.setState({ outputFormat: 'dd/MM/YYYY' });
    }
  }
  handleInputPretermine = event => {
    this.setState({
      autoAnswer: event.target.value,
    });
  };

  handleChangeEmail = chip => {
    let key = chip.key;

    if (chip.isNotPlaceholder !== true) {
      key = '${' + key + '}';
    }

    this.setState({
      notificationEmails: {
        ...this.state.notificationEmails,
        emailList: [...this.state.notificationEmails.emailList, key],
      },
    });
  };

  handleDeleteEmail = index => {
    if (this.state.notificationEmails.emailList) {
      this.state.notificationEmails.emailList.splice(index, 1);
      this.setState({
        notificationEmails: {
          ...this.state.notificationEmails,
          emailList: this.state.notificationEmails.emailList,
        },
      });
    }
  };

  handleShouldNotify = () => {
    this.setState({
      notificationEmails: {
        ...this.state.notificationEmails,
        shouldNotify: !this.state.notificationEmails.shouldNotify,
      },
    });
  };

  handleInputKeyBlur = event => {
    this.setState({
      key: event.target.value,
    });
    this.props.setInnerPlaceholders();
  };

  handleInputKey = event => {
    const pages = SequentialFormContainer.pages;
    const { id } = SequentialFormContainer.editTarget;

    const placeholderValue = replacePlaceholderValue(event.target.value);

    const value = this.checkKey(placeholderValue, id, pages);
    this.setState({
      checkKey: value[0],
      valueError: value[1],
      placeholderValue,
    });
    this.props.handleKeyChanges(value[0]);
  };

  checkKey = (placeholderValue, id, data) => {
    let checkKey = false;
    let errorMessage = '';
    if (placeholderValue.length == 0) {
      checkKey = true;
      errorMessage = 'This field cannot be empty';
    } else if (placeholderValue.length > 0) {
      if (/^[a-zA-Z0-9_]+$/.test(placeholderValue) == false) {
        return [true, 'No special characters or spaces allowed'];
      }
    } else {
      checkKey = false;
    }
    return [checkKey, errorMessage];
  };

  handleInput = (type, event) => {
    const value = event.target.value;
    this.setState({ [type]: value });
  };

  appendInputValue = (type, appendValue) => {
    let realValue = this.state[type] + '' + appendValue;
    this.setState({ [type]: realValue });

    return realValue;
  };

  onClickButtonGroup = (key, name) => {
    const { dataAuto, dataVisibility, dataReadOnly, dataRequired, dataComment } = this.state;
    if (name == 'dataAuto') {
      const dataAnswer = SequentialFormContainer.changeButtonGroup(dataAuto, key);
      this.setState({
        dataAuto: dataAnswer,
        autoAnswer: '',
      });
    }
    if (name == 'dataVisibility') {
      const dataAnswer = SequentialFormContainer.changeButtonGroup(dataVisibility, key);
      this.setState({
        dataVisibility: dataAnswer,
      });
    }
    if (name == 'dataReadOnly') {
      const dataAnswer = SequentialFormContainer.changeButtonGroup(dataReadOnly, key);
      this.setState({
        dataReadOnly: dataAnswer,
      });
    }
    if (name == 'dataRequired') {
      const dataAnswer = SequentialFormContainer.changeButtonGroup(dataRequired, key);
      this.setState({
        dataRequired: dataAnswer,
      });
    }

    if (name == 'dataComment') {
      const dataAnswer = SequentialFormContainer.changeButtonGroup(dataComment, key);
      this.setState({
        dataComment: dataAnswer,
        notificationEmails: {
          emailList: [],
          shouldNotify: false,
        },
      });
    }
  };

  searchable = value => {
    let placeholders = {};
    let availablePlaceholders = [];
    if (value !== '') {
      let data = this.props.availablePlaceholders[0].placeholders.filter(placeholder =>
        placeholder.key.includes(value)
      );
      placeholders['placeholders'] = data;
      availablePlaceholders.push(placeholders);
    } else {
      availablePlaceholders = this.props.availablePlaceholders;
    }
    this.setState({
      availablePlaceholders: availablePlaceholders,
    });
  };

  hasTextValidation = () => {
    const { type } = SequentialFormContainer.editTarget;
    const textTypes = [
      9, // Short Text
      2, // Long Text
    ];
    return textTypes.includes(type);
  };

  hasNumberValidation = () => {
    const { type } = SequentialFormContainer.editTarget;
    const numberTypes = [
      1, // Number Input
    ];
    return numberTypes.includes(type);
  };

  render() {
    const {
      dataAuto,
      dataVisibility,
      dataReadOnly,
      dataRequired,
      dataComment,
      required,
      readonly,
      visibility,
      autoAnswer,
      file_type,
      notificationEmails,
    } = this.state;

    const { type } = SequentialFormContainer.editTarget;
    const target = SequentialFormContainer.editTarget;

    const { classes } = this.props;
    return (
      <div style={{ overflow: 'hidden' }}>
        {type != 16 && (
          <>
            <Grid container item xs={12} direction={'row'} alignItems={'center'}>
              <Grid item>
                <p style={{ marginRight: '16px' }}>Placeholder</p>{' '}
              </Grid>

              <Grid item xs>
                <W86PlaceholderTextField
                  placeholderText="Enter placeholder name"
                  value={this.state.placeholderValue}
                  defaultValue={this.state.key}
                  handleChange={this.handleInputKey}
                  error={this.state.checkKey}
                  helperText={this.state.valueError}
                  onBlur={this.handleInputKeyBlur}
                  disableAdornment={false}
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={1}>
                <Tooltip
                  title="This will identity the data output of this question."
                  placement="right-start"
                  componentsProps={{
                    tooltip: {
                      sx: { fontSize: 12, p: '8px 16px', fontFamily: 'Open Sans', bgcolor: 'rgba(0,0,0,0.7)', borderRadius: '6px' }
                    }
                  }}
                >
                  <HelpOutlineIcon className="custom-icon-btn" sx={{ fontSize: 16 }} />
                </Tooltip>
              </Grid>
            </Grid>
            {/* QUESTION TEXT */}
            {type !== 11 && (
              <div style={{ marginBottom: 16 }}>
                {this.state.question_text_default !== null && (
                  <div className="mention-editor-container">
                    <span className="mention-editor-label">Question</span>
                    <FormMentionEditor
                      style={{
                        width: '100%',
                        marginBottom: 16,
                        verticalAlign: 'top',
                        minHeight: '16px',
                      }}
                      contentBlock={false}
                      assignTask={true}
                      availablePlaceholders={this.props.availablePlaceholders}
                      text={
                        this.state.question_text_default ? this.state.question_text_default : ''
                      }
                      placeholder={type != 11 ? 'Enter your question' : 'Enter Heading'}
                      onChange={value => {
                        this.setState({ ['question_text_default']: value });
                      }}
                      onFocus={e => {}}
                      ref={this.questionMentionInstance}
                      hideScrollBar={true}
                      {...(this.props.availablePlaceholders != null && {
                        availablePlaceholders: this.props.availablePlaceholders,
                      })}
                    />
                  </div>
                )}
              </div>
            )}
            {/* QUESTION DESCRIPTION */}
            {type !== 11 && (
              <div>
                {this.state.question_description_default !== null && (
                  <div className="mention-editor-container">
                    <span className="mention-editor-label">Description</span>
                    <FormMentionEditor
                      style={{
                        width: '100%',
                        marginBottom: 16,
                        verticalAlign: 'top',
                        minHeight: '16px',
                      }}
                      availablePlaceholders={this.props.availablePlaceholders}
                      text={this.state.question_description_default}
                      placeholder={
                        type != 11 ? 'Enter a question description' : 'Enter Sub-heading'
                      }
                      onChange={value => {
                        this.setState({
                          ['question_description_default']: value,
                        });
                      }}
                      onFocus={e => {}}
                      hideScrollBar={true}
                      ref={this.questionDescnMentionInstance}
                      contentBlock={false}
                      assignTask={true}
                      {...(this.props.availablePlaceholders != null && {
                        availablePlaceholders: this.props.availablePlaceholders,
                      })}
                    />
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {/* VALIDATION */}
        {this.hasTextValidation() && (
          <TextValidation
            validation={this.state.validation}
            assignTask={true}
            setInnerPlaceholders={this.props.setInnerPlaceholders}
            availablePlaceholders={this.props.availablePlaceholders}
            onChange={newValidation => {
              this.setState({
                validation: newValidation,
              });
            }}
          />
        )}
        {this.hasNumberValidation() && (
          <NumberValidation
            validation={this.state.validation}
            assignTask={true}
            setInnerPlaceholders={this.props.setInnerPlaceholders}
            availablePlaceholders={this.props.availablePlaceholders}
            onChange={newValidation => {
              this.setState({
                validation: newValidation,
              });
            }}
          />
        )}
        {/* CONTENT BLOCK */}
        {type == 11 && this.state.answer_data_default !== null && (
          <div>
            <div className="mention-editor-container">
              <FormMentionEditor
                availablePlaceholders={this.props.availablePlaceholders}
                text={this.state.answer_data_default}
                onChange={html =>
                  this.setState({
                    answer_data_default: html,
                  })
                }
                placeholder={''}
                disableTooltip
                contentStyles={{
                  border: '1px solid rgba(0, 0, 0, 0.16)',
                  boxShadow: 'none',
                  height: 'auto',
                  minHeight: '360px',
                  padding: '8px',
                  minWidth: '100%',
                }}
                onFocus={e => {}}
                ref={this.questionMentionInstance}
                editorFocus={() => {
                  this.setState({ focus: 'editor' });
                }}
                contentBlock={true}
                hideScrollBar={true}
                assignTask={true}
                {...(this.props.availablePlaceholders != null && {
                  availablePlaceholders: this.props.availablePlaceholders,
                })}
              />
            </div>
          </div>
        )}
        {/* LIST QUESTION TYPE */}
        {type == 12 && (
          <Grid container direction="column">
            <p>Control the number of entries to the list</p>
            <Grid container>
              <Select
                className="select-list"
                variant="outlined"
                value={this.state.list_value_restrict}
                onChange={event => {
                  this.setState({ list_value_restrict: event.target.value });
                }}
              >
                <MenuItem value={0}>No limit</MenuItem>
                <MenuItem value={1}>Set maximum</MenuItem>
                <MenuItem value={2}>Set minimum</MenuItem>
                <MenuItem value={3}>Set maximum and minimum</MenuItem>
              </Select>
              {this.state.list_value_restrict == 0 ? (
                ' '
              ) : this.state.list_value_restrict == 1 ? (
                <Grid container direction="column">
                  <p>Maximum number of values that can be entered:</p>
                  <TextFieldUI
                    className={'numberInput'}
                    placeholder={'Enter a number'}
                    value={this.state.maxItems}
                    onChange={event => {
                      this.setState({ maxItems: event.target.value });
                    }}
                    type="number"
                    variant="outlined"
                    InputProps={{
                      classes: { input: classes.formAreaInput },
                      inputProps: { min: 2, max: 100 },
                    }}
                  />
                </Grid>
              ) : this.state.list_value_restrict == 2 ? (
                <Grid container direction="column">
                  <p>The user must enter a minimum of this many entries to the list:</p>
                  <TextFieldUI
                    className={'numberInput'}
                    placeholder={'Enter a number'}
                    value={this.state.minItems}
                    onChange={event => {
                      this.setState({ minItems: event.target.value });
                    }}
                    type="number"
                    variant="outlined"
                    InputProps={{
                      classes: { input: classes.formAreaInput },
                      inputProps: { min: 2, max: 100 },
                    }}
                  />
                </Grid>
              ) : this.state.list_value_restrict == 3 ? (
                <Grid container direction="column">
                  <p>The user must enter a minimum of this many entries to the list:</p>
                  <TextFieldUI
                    className={'numberInput'}
                    placeholder={'Enter a number'}
                    value={this.state.minItems}
                    onChange={event => {
                      this.setState({ minItems: event.target.value });
                    }}
                    type="number"
                    variant="outlined"
                    InputProps={{
                      classes: { input: classes.formAreaInput },
                      inputProps: { min: 2, max: 100 },
                    }}
                  />
                  <p>The user can only enter a maximum of this many entries to the list:</p>
                  <TextFieldUI
                    className={'numberInput'}
                    placeholder={'Enter a number'}
                    value={this.state.maxItems}
                    onChange={event => {
                      this.setState({ maxItems: event.target.value });
                    }}
                    type="number"
                    variant="outlined"
                    InputProps={{
                      classes: { input: classes.formAreaInput },
                      inputProps: { min: 2, max: 100 },
                    }}
                  />
                </Grid>
              ) : (
                ' '
              )}
            </Grid>
          </Grid>
        )}
        {type == 14 && (
          <div>
            <div className={classes.filePreviewURL}>URL of file to preview</div>
            <div>
              {this.state.question_text_default !== null && (
                <FormMentionEditor
                  style={{
                    width: '100%',
                    marginBottom: 16,
                    verticalAlign: 'top',
                    minHeight: '16px',
                  }}
                  availablePlaceholders={this.props.availablePlaceholders}
                  contentBlock={false}
                  assignTask={true}
                  text={this.state.answer_data_default ? this.state.answer_data_default : ''}
                  placeholder="Insert URL of the file to preview"
                  onChange={value => {
                    this.setState({ answer_data_default: value });
                  }}
                  onFocus={e => {}}
                  ref={this.questionMentionInstance}
                  hideScrollBar={true}
                  {...(this.props.availablePlaceholders != null && {
                    availablePlaceholders: this.props.availablePlaceholders,
                  })}
                />
              )}
            </div>
            <div className={classes.filePreviewURL}>Select file type</div>
            <div>
              <Select
                onChange={e => {
                  this.setState({
                    file_type: e.target.value,
                  });
                }}
                value={file_type}
                className={'selection'}
                style={{ width: '100%' }}
              >
                <MenuItem value={'pdf'}>.pdf</MenuItem>
                <MenuItem value={'docx'}>.docx</MenuItem>
                <MenuItem value={'pptx'}>.pptx</MenuItem>
                <MenuItem value={'csv'}>.csv</MenuItem>
                <MenuItem value={'xlsx'}>.xlsx</MenuItem>
                <MenuItem value={'png'}>.png, .jpeg, .gif, .bmp</MenuItem>
              </Select>
            </div>
          </div>
        )}
        {type == 7 ? (
          <Calendar
            preview={false}
            outputFormat={this.state.outputFormat}
            timezone={this.state.timezone}
            dateOnly={this.state.dateOnly}
            handleChangeOutput={this.handleChangeOutput}
            handleChangeTimezone={this.handleChangeTimezone}
            handleChangeDateOnly={this.handleChangeDateOnly}
          />
        ) : (
          ''
        )}
        {type == 15 ? (
          <Table
            preview={false}
            numRows={this.state.numRows}
            setNumRows={rowCount => this.setState({ numRows: rowCount })}
            exportType={this.state.exportType}
            setExportType={exportType => this.setState({ exportType: exportType })}
            columns={this.state.columns}
            setColumns={updatedColumns => this.setState({ columns: updatedColumns })}
            rowLabels={this.state.rowLabels}
            setRowLabels={updatedRowLabels => this.setState({ rowLabels: updatedRowLabels })}
            tableErrors={this.state.tableErrors}
            setTableErrors={tableErrs => this.setState({ tableErrors: tableErrs })}
            handleKeyChanges={this.props.handleKeyChanges}
            tableCells={this.state.tableCells}
            setTableCells={updatedCells => this.setState({ tableCells: updatedCells })}
            availablePlaceholders={this.props.availablePlaceholders}
          />
        ) : (
          ''
        )}
        {type == 19 && (
          <RepeatableSection
            preview={false}
            numRows={this.state.numRows}
            setNumRows={rowCount => this.setState({ numRows: rowCount })}
            exportType={this.state.exportType}
            setExportType={exportType => this.setState({ exportType: exportType })}
            exportFormat={this.state.exportFormat}
            setExportFormat={exportFormat => this.setState({ exportFormat: exportFormat })}
            columns={this.state.columns}
            setColumns={updatedColumns => this.setState({ columns: updatedColumns })}
            rowLabels={this.state.rowLabels}
            setRowLabels={updatedRowLabels => this.setState({ rowLabels: updatedRowLabels })}
            tableErrors={this.state.tableErrors}
            setTableErrors={tableErrs => this.setState({ tableErrors: tableErrs })}
            handleKeyChanges={this.props.handleKeyChanges}
            tableCells={this.state.tableCells}
            setTableCells={updatedCells => this.setState({ tableCells: updatedCells })}
            availablePlaceholders={this.props.availablePlaceholders}
          />
        )}
        {type == 4 || type == 5 || type == 10 ? (
          <ChoiceQuestion
            answer_list={this.state.answer_list}
            handleAddpair={() => {
              this.handleAddpair();
            }}
            handlePoppair={index => {
              this.handlePoppair(index);
            }}
            handleAnswerpair={(key, type, value) => {
              this.handleAnswerpair(key, type, value);
            }}
            handleReplaceAnswerList={newAnsList => {
              this.handleReplaceAnswerList(newAnsList);
            }}
            type={type}
            databaseId={SequentialFormContainer.editTarget.config.databaseId}
            optionsSource={SequentialFormContainer.editTarget.config.optionsSource}
            handleChangeChoiceAnswerOption={newOption => {
              this.setState({ optionsSource: newOption });
            }}
            availablePlaceholders={this.props.availablePlaceholders}
            columnId={SequentialFormContainer.editTarget.config.columnId}
            changeColumn={columnId => {
              this.setState({ columnId: columnId });
            }}
            labelColumnId={
              SequentialFormContainer.editTarget.config.labelColumnId
                ? SequentialFormContainer.editTarget.config.labelColumnId
                : null
            }
            changeColumnLabel={columnId => {
              this.setState({ labelColumnId: columnId, columnId: '' });
            }}
            changeColumnValue={columnId => {
              this.setState({ valueColumnId: columnId, columnId: '' });
            }}
            valueColumnId={
              SequentialFormContainer.editTarget.config.valueColumnId
                ? SequentialFormContainer.editTarget.config.valueColumnId
                : null
            }
            changeDb={databaseId => {
              this.setState({ databaseId: databaseId });
            }}
            resetAnswerList={() => {
              this.setState({ answer_list: [['', '']] });
            }}
            removeDbInfo={() => {
              this.setState({ databaseId: '', columnId: '' });
              SequentialFormContainer.editTarget.config.databaseId = '';
              SequentialFormContainer.editTarget.config.columnId = '';
            }}
          />
        ) : (
          ''
        )}{' '}
        {/*VIDEO EMBED*/}
        {type === 16 && (
          <VideoEmbed
            target={target}
            setTarget={updatedTarget => {
              this.setState({
                size: updatedTarget.config.size,
                height: updatedTarget.config.height,
                width: updatedTarget.config.width,
                embedType: updatedTarget.config.embedType,
                url: updatedTarget.config.url,
                snippet: updatedTarget.config.snippet,
              });
            }}
          />
        )}{' '}
        {/*IMAGE ANNOTATION*/}
        {type === 20 && (
          <div>
            <Grid container direction="column" style={{ marginBottom: 16 }}>
              <p style={{ fontWeight: 500, marginBottom: 8 }}>Image source</p>
              <FormControl>
                <RadioGroup
                  value={this.state.sourceMode || 'user_upload'}
                  onChange={e => {
                    this.setState({ sourceMode: e.target.value, presetImageUrl: '' });
                  }}
                >
                  <FormControlLabel
                    value="user_upload"
                    control={<Radio size="small" />}
                    label="User uploads an image"
                  />
                  <FormControlLabel
                    value="preset_url"
                    control={<Radio size="small" />}
                    label="Preset image from URL"
                  />
                  <FormControlLabel
                    value="preset_upload"
                    control={<Radio size="small" />}
                    label="Upload a preset image"
                  />
                </RadioGroup>
              </FormControl>
              {this.state.sourceMode === 'preset_url' && (
                <div style={{ marginTop: 8 }}>
                  <p style={{ fontSize: 13, color: 'var(--mui-palette-text-secondary)', marginBottom: 8 }}>
                    Enter an image URL or select a placeholder. This image will be shown to the form user for annotation.
                  </p>
                  <div className="mention-editor-container">
                    <FormMentionEditor
                      style={{
                        width: '100%',
                        marginBottom: 8,
                        verticalAlign: 'top',
                        minHeight: '16px',
                      }}
                      assignTask={true}
                      text={this.state.presetImageUrl || ''}
                      placeholder="Enter image URL or select a placeholder"
                      onChange={value => {
                        this.setState({ presetImageUrl: value });
                      }}
                      onFocus={e => {}}
                      hideScrollBar={true}
                      {...(this.props.availablePlaceholders != null && {
                        availablePlaceholders: this.props.availablePlaceholders,
                      })}
                    />
                  </div>
                  {this.state.presetImageUrl && !this.state.presetImageUrl.includes('{{') && (
                    <div style={{ marginTop: 8 }}>
                      <img
                        src={this.state.presetImageUrl}
                        alt="Preset preview"
                        style={{ maxWidth: '100%', maxHeight: 150, borderRadius: 4, border: '1px solid var(--mui-palette-divider)' }}
                      />
                    </div>
                  )}
                </div>
              )}
              {this.state.sourceMode === 'preset_upload' && (
                <div style={{ marginTop: 8 }}>
                  <p style={{ fontSize: 13, color: 'var(--mui-palette-text-secondary)', marginBottom: 8 }}>
                    Upload an image file. This image will be shown to the form user for annotation.
                  </p>
                  <Button
                    variant="outlined"
                    size="small"
                    component="label"
                    style={{ textTransform: 'none' }}
                    disabled={this.state.presetImageUploading}
                  >
                    {this.state.presetImageUploading ? 'Uploading...' : 'Choose image file'}
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={async e => {
                        const file = e.target.files[0];
                        if (!file) return;
                        this.setState({ presetImageUploading: true });
                        try {
                          const url = await uploadImage(file, useProjectStore.getState().project_id);
                          if (url) {
                            this.setState({ presetImageUrl: url });
                          }
                        } catch (err) {
                          console.error('Failed to upload preset image', err);
                        } finally {
                          this.setState({ presetImageUploading: false });
                        }
                      }}
                    />
                  </Button>
                  {this.state.presetImageUrl && (
                    <div style={{ marginTop: 8 }}>
                      <img
                        src={this.state.presetImageUrl}
                        alt="Preset preview"
                        style={{ maxWidth: '100%', maxHeight: 150, borderRadius: 4, border: '1px solid var(--mui-palette-divider)' }}
                      />
                    </div>
                  )}
                </div>
              )}
            </Grid>
          </div>
        )}
        {/*ADDRESS*/}
        {type === 21 && (
          <div>
            <Grid container direction="column" style={{ marginBottom: 16 }}>
              <p style={{ fontWeight: 500, marginBottom: 8 }}>Address fields</p>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <p style={{ fontSize: 12, color: 'var(--mui-palette-text-secondary)', marginBottom: 4 }}>Field</p>
                </Grid>
                <Grid item xs={3}>
                  <p style={{ fontSize: 12, color: 'var(--mui-palette-text-secondary)', marginBottom: 4 }}>Show</p>
                </Grid>
                <Grid item xs={3}>
                  <p style={{ fontSize: 12, color: 'var(--mui-palette-text-secondary)', marginBottom: 4 }}>Required</p>
                </Grid>
              </Grid>
              {[
                { key: 'line1', label: 'Address line 1' },
                { key: 'line2', label: 'Address line 2' },
                { key: 'locality', label: 'City / Locality' },
                { key: 'region', label: 'State / Region' },
                { key: 'postalCode', label: 'Postal / ZIP code' },
                { key: 'country', label: 'Country' },
              ].map(field => {
                const addressFields = this.normalizeAddressFieldConfig(
                  this.state.addressFields
                );
                const value = addressFields[field.key];
                return (
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    key={field.key}
                    style={{ marginBottom: 2 }}
                  >
                    <Grid item xs={6}>
                      <p style={{ margin: 0 }}>{field.label}</p>
                    </Grid>
                    <Grid item xs={3}>
                      <Checkbox
                        checked={Boolean(value?.show)}
                        onChange={this.handleAddressFieldConfigChange(field.key, 'show')}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Checkbox
                        checked={Boolean(value?.required)}
                        onChange={this.handleAddressFieldConfigChange(field.key, 'required')}
                        disabled={!value?.show}
                        size="small"
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        )}
        {/*RICH TEXT EDITOR*/}
        {type === 17 && (
          <div>
            <div className="rich-text-prefill-container">
              <FormMentionEditor
                style={{
                  width: '100%',
                  marginBottom: 16,
                  verticalAlign: 'top',
                }}
                assignTask={true}
                contentBlock={true}
                text={this.state.defaultContent}
                onChange={html => {
                  this.setState({
                    defaultContent: html,
                  });
                }}
                disableTooltip
                onFocus={e => {}}
                ref={this.questionMentionInstance}
                contentStyles={{
                  border: '1px solid rgba(0, 0, 0, 0.16)',
                  borderRadius: '4px',
                  boxShadow: 'none',
                  padding: 0,
                  minWidth: '100%',
                  minHeight: '500px',
                }}
                hideScrollBar={true}
                {...(this.props.availablePlaceholders != null && {
                  availablePlaceholders: this.props.availablePlaceholders,
                })}
              />
            </div>
          </div>
        )}
        {type !== 16 && (
          <>
            <Grid
              className={'advanced'}
              container
              item
              xs={12}
              direction={'row'}
              alignItems={'center'}
            >
              <p
                onClick={() => {
                  this.setState({ advancedExpand: !this.state.advancedExpand });
                }}
                className="s-text custom-icon-btn narrow"
              >
                Advanced Settings
                {this.state.advancedExpand ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </p>

              <Tooltip
                title="Control features including whether the question must be answered, prefill the question answer, question visibility and whether it is read-only."
                placement="right-start"
                componentsProps={{
                  tooltip: {
                    sx: { fontSize: 12, p: '8px 16px', fontFamily: 'Open Sans', bgcolor: 'rgba(0,0,0,0.7)', borderRadius: '6px' }
                  }
                }}
              >
                <HelpOutlineIcon className="custom-icon-btn narrowIcon" sx={{ fontSize: 16 }} />
              </Tooltip>
            </Grid>

            {this.state.advancedExpand && (
              <div>
                {type !== 17 && (
                  <div>
                    <Grid container item xs={12} direction={'row'} alignItems={'center'}>
                      <p className={'bold margin'}>Comments:</p>
                      <p className={'s-text'}>Allow users to enter a comment for this question</p>
                    </Grid>
                    <ButtonGroup
                      onClickButton={key => {
                        this.onClickButtonGroup(key, 'dataComment');
                      }}
                      size="small"
                      data={dataComment}
                    />
                    {dataComment && dataComment[0].active && notificationEmails != null && (
                      <Grid
                        container
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                        marginTop={'16px'}
                      >
                        <Grid item xs={12}>
                          <Checkbox
                            checked={notificationEmails.shouldNotify}
                            onClick={this.handleShouldNotify}
                            className="notify-email-checkbox"
                            size="medium"
                          />
                          <span className="comment-email-text">
                            Send email when a new comment is posted
                          </span>
                        </Grid>
                        {notificationEmails.shouldNotify && (
                          <Grid item xs={12} marginTop={'8px'}>
                            <ChipInput
                              inputValue={notificationEmails.emailList}
                              fullWidth={true}
                              placeholder={'Type in an email'}
                              onPlaceholderSelected={this.handleChangeEmail}
                              onDelete={index => {
                                this.handleDeleteEmail(index);
                              }}
                              placeholders={this.props.availablePlaceholders}
                            />
                          </Grid>
                        )}
                      </Grid>
                    )}
                  </div>
                )}
                {type != 11 && type != 14 && type != 15 && type != 19 && (
                  <div>
                    <Grid xs={12} direction={'row'} container item>
                      <p className={'bold margin'}>Required: </p>
                      <p className={'s-text'}>control whether this question must be answered</p>
                    </Grid>
                    <ButtonGroup
                      onClickButton={key => {
                        this.onClickButtonGroup(key, 'dataRequired');
                      }}
                      size="small"
                      data={dataRequired}
                    />
                    {dataRequired[2].active && (
                      <FormRequired
                        required={required}
                        availablePlaceholders={this.props.availablePlaceholders}
                      />
                    )}
                  </div>
                )}
                {type != 11 &&
                  type != 6 &&
                  type != 13 &&
                  type != 15 &&
                  type != 17 &&
                  type != 19 &&
                  type != 20 &&
                  type != 21 && (
                    <div>
                      <Grid xs={12} container item direction={'row'}>
                        <p className={'bold margin'}>Prefill answer: </p>
                        <p className={'s-text'}>
                          prefill the answer to this question based on a default value or
                          conditional statement
                        </p>
                      </Grid>
                      <ButtonGroup
                        onClickButton={key => {
                          this.onClickButtonGroup(key, 'dataAuto');
                        }}
                        size="small"
                        data={dataAuto}
                      />
                      {dataAuto && dataAuto[0].active && (
                        <>
                          <div className="mention-editor-container">
                            <span className="mention-editor-label">Prefilled value</span>
                            <FormMentionEditor
                              style={{
                                width: '100%',
                                marginBottom: 8,
                                marginTop: 16,
                                verticalAlign: 'top',
                                minHeight: '16px',
                              }}
                              contentBlock={false}
                              assignTask={true}
                              availablePlaceholders={this.props.availablePlaceholders}
                              text={this.state.autoAnswer ? this.state.autoAnswer : ''}
                              onChange={value => {
                                this.setState({
                                  autoAnswer: value,
                                });
                              }}
                              onFocus={e => {}}
                              ref={this.inputPretermineInstance}
                              hideScrollBar={true}
                              {...(this.props.availablePlaceholders != null && {
                                availablePlaceholders: this.props.availablePlaceholders,
                              })}
                            />
                            {(type === 4 || type === 5 || type === 10) && (
                              <Grid
                                container
                                item
                                direction={'row'}
                                alignItems={'center'}
                                className={classes.warningGrid}
                              >
                                <ErrorIcon className={classes.warningIcon} />
                                <p className={classes.warningText}>
                                  Prefilled value must be an exact match with the Answer Value, or
                                  the Answer Option if Answer Value has not been set
                                </p>
                              </Grid>
                            )}
                          </div>
                        </>
                      )}
                      {type == 12 && dataAuto && dataAuto[0] && dataAuto[0].active ? (
                        <p className="s-text m-0" style={{ fontSize: '12px' }}>
                          Enter values separated by a comma
                        </p>
                      ) : (
                        ''
                      )}
                      {dataAuto[2].active && (
                        <>
                          <FormPredertermine
                            autoAnswer={autoAnswer}
                            availablePlaceholders={this.props.availablePlaceholders}
                          />
                          {type == 12 && (
                            <p className="s-text m-0" style={{ fontSize: '12px' }}>
                              Enter values separated by a comma
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  )}
                <div>
                  <div>
                    <Grid container item xs={12} direction={'row'}>
                      <p className={'bold margin'}>Visibility: </p>
                      <p className={'s-text'}>control whether this question is shown or hidden</p>
                    </Grid>
                    <ButtonGroup
                      onClickButton={key => {
                        this.onClickButtonGroup(key, 'dataVisibility');
                      }}
                      size="small"
                      data={dataVisibility}
                    />
                  </div>
                  {dataVisibility[2].active && (
                    <FormVisibility
                      visibility={visibility}
                      availablePlaceholders={this.props.availablePlaceholders}
                    />
                  )}
                </div>
                {type != 11 && type != 6 && type != 14 && (
                  <div>
                    <div>
                      <Grid xs={12} container item direction={'row'}>
                        <p className={'bold margin'}>Read Only: </p>
                        <p className={'s-text'}>control whether this question is read-only</p>
                      </Grid>
                      <ButtonGroup
                        onClickButton={key => {
                          this.onClickButtonGroup(key, 'dataReadOnly');
                        }}
                        size="small"
                        data={dataReadOnly}
                      />
                    </div>
                    {dataReadOnly[2].active && (
                      <FormReadOnly
                        readonly={readonly}
                        availablePlaceholders={this.props.availablePlaceholders}
                      />
                    )}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

ComponentConfig.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComponentConfig);
